import { useEffect, useState, type FormEvent } from 'react';
import { api } from '../lib/api.js';

export function KeywordsPage(): JSX.Element {
  const [keywords, setKeywords] = useState<Array<{ id: string; phrase: string }>>([]);
  const [phrase, setPhrase] = useState('');
  const [error, setError] = useState<string | null>(null);

  async function load(): Promise<void> {
    try {
      setKeywords(await api.listKeywords());
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  }

  useEffect(() => {
    void load();
  }, []);

  async function onAdd(e: FormEvent): Promise<void> {
    e.preventDefault();
    const p = phrase.trim();
    if (!p) return;
    try {
      await api.createKeyword(p);
      setPhrase('');
      await load();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  }

  async function onDelete(id: string): Promise<void> {
    await api.deleteKeyword(id);
    await load();
  }

  return (
    <div>
      <h1 className="page-title">Keywords</h1>
      <p className="page-subtitle">
        Flag meetings whose transcripts mention these phrases.
      </p>

      {error && <div className="form-error" style={{ marginBottom: 14 }}>{error}</div>}

      <form className="join-form" onSubmit={(e) => void onAdd(e)} style={{ marginBottom: 20 }}>
        <div className="form-row">
          <label className="form-label" htmlFor="phrase">Add keyword</label>
          <input
            id="phrase"
            value={phrase}
            onChange={(e) => setPhrase(e.target.value)}
            placeholder="e.g. budget, Q4, competitor"
            maxLength={100}
          />
        </div>
        <button type="submit" className="btn">Add</button>
      </form>

      <div className="panel">
        {keywords.length === 0 && <p className="panel__subtle">No keywords yet.</p>}
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
          {keywords.map((k) => (
            <button
              key={k.id}
              type="button"
              className="speaker-chip"
              title="Click to remove"
              onClick={() => void onDelete(k.id)}
            >
              <span className="speaker-chip__name">{k.phrase}</span>
              <span style={{ opacity: 0.5 }}>×</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
